import { Component, OnInit, ViewChild } from '@angular/core';
import { GridViewComponent } from 'src/app/shared/components/grid-view/grid-view.component';
import { LookUp } from 'src/app/front-user/shared/models/look-up.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { Languages } from 'src/app/shared/models/enums.model';
import { Listing } from 'src/app/shared/models/listing.model';
import { AppConfig } from 'src/app/shared/services/app.config';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-supplier-tender-list',
  templateUrl: './supplier-tender-list.component.html',
  styles: []
})
export class SupplierTenderListComponent implements OnInit {
  private collection: Listing;
  @ViewChild('ETenderList',{static: false}) gridView: GridViewComponent;
  pageSize = 10;
  category: number = null;
  private itemsMenu: MenuItem[] = [];
  hideExportButton: boolean;
  TenderCategories: LookUp[];
  displayedLang: string;
  HasMenu = true;
  HasMenuButtons = true;
  IsHtml = false;
  currentUser: string;
  constructor(private global: GlobalServices, private etenderSrv: EtenderService,
              private lookupSrv: LookupService, private authSrevice: AuthenticationService,
              private alertService: AlertService, private translate: TranslateService, private router: Router) {
    this.displayedLang = this.global.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.currentUser = this.authSrevice.currentUserValue == null ? '' : this.authSrevice.currentUserValue.UserId;
  }


  ngOnInit() {
    this.loadLookups();
    this.loadData();

  }
  loadCollectionCompleted() {
    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      'ETender/GetSupplierETenderPaged?pageIndex={PAGEINDEX}&pageSize=' + this.pageSize +
      '&language=' + (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En') + '&category=' + this.category +
      '&currentUser=' + this.currentUser, 'ADMIN_USER.ETENDER_SUPPLIER_VIEW_OBJECT', this.itemsMenu, '', '', 'GetSupplierETenderPaged');
    this.global.isLoaderEnabled = false;
  }
  ExportExcel() {
    this.translate.get('ADMIN_USER.ETENDER_SUPPLIER_VIEW_OBJECT').subscribe((response: string) => {
      const ExportExcelUrl = AppConfig.settings.apiServer.apiUrl +
        'ETender/ExportSupplierETenderExcel?eTenderObject=' + JSON.stringify(response) +
        '&language=' + (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En') +
        '&category=' + this.category + '&currentUser=' + this.currentUser;

      window.open(ExportExcelUrl, '_self');
    });
  }
  resetData() {
    this.category = null;
    this.hideExportButton = false;
    this.loadData();

  }
  loadData() {
    this.category = this.category == null ? null : this.category;
    this.global.isLoaderEnabled = true;
    this.etenderSrv.GetSupplierETenderPaged(0, this.pageSize, this.category, this.currentUser, (this.global.getLanguage() == Languages.Arabic ? 'Ar' : 'En')).subscribe(

      d => {

        this.collection = d.Data;
        this.hideExportButton = this.collection.Collection.length > 0 ? false : true;
      },
      () => console.log('Something went wrong!!'),
      () => this.loadCollectionCompleted()

    );
  }
  loadLookups() {
    this.global.isLoaderEnabled = true;
    this.lookupSrv.getTenderLookups().subscribe(d => {
      this.TenderCategories = d.Data.Categories;
      this.global.isLoaderEnabled = false;
    });
  }
  View(id, type) {
    if (id) {
      if (type == this.translate.instant('ADMIN_USER.E_TENDER_FORM.PUBLIC_BIDDING')) {
        this.router.navigate(['/ViewTender'], { state: { data: { tenderId: id } } });
      } else {
        this.router.navigate(['/TenderViewAllFieldsComponent'], { state: { data: { tenderId: id, supplierId: this.currentUser } } });
      }
    }
  }
}

export class MenuItem {
  Title: string;
  TitleAr: string;
  Action: string;
}
